// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-5b87551d]{font-size:12px;line-height:16px;color:#797b87;margin-top:17px}a[data-v-5b87551d]{text-decoration:none;color:#158ad2}", ""]);
// Exports
module.exports = exports;
